import React, { useEffect, useRef, useState } from "react";
import { Grid, Divider, Box } from "@material-ui/core";
import {
  MasterButton,
  InputOptionMaster,
  InputTextMaster,
  InputReactDatepicker,
  ModalExportList,
} from "App/Component/ui";
import { BASE_URL_3, TYPE_INSTANCE4 } from "App/constants";
import { useSelectOption } from "App/hooks";
import {
  getByFilterFixedAssetExport,
  RESET_STATE_FORM_FILTER,
} from "./helpers";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import {} from "App/Component/layout/MasterData/helpers";
import { getIDunit } from "App/utils/cookies";
import { useSelector } from "react-redux";
export default function FormFilter({
  formFilter,
  setFormFilter,
  setNewData,
  typeButton = "submit",
  disabledStatus = false,
  withExportButton = false,
}) {
  const master = useSelector(({ master }) => master);
  const fullAkses = master.access_fa.access;

  const [showModalExportList, setShowModalExportList] = useState(false);
  //   const [rowsExport, setRowsExport] = useState([]);
  //   const [readyExport, setReadyExport] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  //   const csvLink = useRef(null);
  const handleChange = (text) => (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    await setNewData();
  };

  const tipe_asset = useSelectOption(
    false,
    "/wmsassets/master/typeassets/listms_type_assets",
    TYPE_INSTANCE4
  );

  const produsen = useSelectOption(
    false,
    "/wmsMasterAsset/master/list-produsen",
    TYPE_INSTANCE4
  );

  const gudangUtama = useSelectOption(
    true,
    "/wmsMasterAsset/gudang/list",
    TYPE_INSTANCE4,
    "gudangId",
    "name",
    "body",
    fullAkses ? {} : isNull(getIDunit())
      ? {}
      : {
          params: {
            unit: getIDunit(),
          },
        }
  );

  const supplier = useSelectOption(
    true,
    "/wmsMasterAsset/master/list-supplier",
    TYPE_INSTANCE4
  );

  const handleExport = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const res = await getByFilterFixedAssetExport({
        ...formFilter,
        withFilterUnit: !fullAkses,
        unit_id: fullAkses ? null : getIDunit(),
      });
      if (res.state) {
        defaultToastSuccess(
          "Berhasil, mohon menunggu data sedang dieksport..."
        );
      } else {
        defaultToastError(res.message);
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      defaultToastError(error?.response?.data?.message);
    }
  };

  //   const prepareHeaders = {
  //     id: "id_fixedAsset",
  //     name: "nama",
  //     code: "code",
  //     merek: "merek",
  //     type: "type",
  //     idgl: "idgl",
  //     no_akl: "no_akl",
  //     no_sn: "no_sn",
  //     no_akd: "no_akd",
  //     nama_fiscal: "nama_fiscal",
  //     nama_typeasset: "nama_typeasset",
  //     id_pembelian: "id_pembelian",
  //     nofaktur: "nofaktur",
  //     tgl_pembelian: "tgl_pembelian:date",
  //     tgl_pemakaian: "tgl_pemakaian:date",
  //     tgl_akhirpenyusutan: "tgl_akhirpenyusutan:date",
  //     perkiraan_umur_thn: "perkiraan_umur_thn",
  //     perkiraan_umur_bln: "perkiraan_umur_bln",
  //     gudang: "gudang",
  //     supplier: "supplier",
  //     produsen: "produsen",
  //     status_kelengkapan: "status_kelengkapan",
  //     harga_perolehan: "harga_perolehan",
  //     nilai_aset: "nilai_aset",
  //     nilai_penyusutan: "nilai_penyusutan",
  //     total_penyusutan: "total_penyusutan",
  //     total_cicilan: "total_cicilan",
  //     sisa_pemby: "sisa_pemby",
  //     is_asetberwujud: "is_asetberwujud",
  //     is_perhitungansusut: "is_perhitungansusut",
  //     masa_manfaat: "masa_manfaat",
  //     tarif_penyusutan: "tarif_penyusutan",
  //     status: "status",
  //     unit: "unit",
  //     coa_fixassets: "coa_fixassets",
  //     coa_fixassets_code: "coa_fixassets_code",
  //     coa_akumulasi: "coa_akumulasi",
  //     coa_akumulasi_code: "coa_akumulasi_code",
  //     coa_bebanpenyusutan: "coa_bebanpenyusutan",
  //     coa_bebanpenyusutan_code: "coa_bebanpenyusutan_code",
  //     kondisi_barang: "kondisi_barang",
  //     is_swict_coa: "is_swict_coa",
  //     remark: "remark",
  //     createdBy: "createdBy",
  //     createdAt: "inserted_time:date",
  //     createdName: "inserted_by",
  //     updatedAt: "updated_time:date",
  //     updatedName: "updated_by",
  //   };

  //   const dataExport = PrepareDataExport(rowsExport, prepareHeaders);
  //   const headerExport = FilterColumns(dataExport);

  //   useEffect(() => {
  //     if (csvLink && csvLink.current && readyExport) {
  //       csvLink.current.link.click();
  //     }
  //   }, [readyExport]);

  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={3}>
          <Grid item sm={3}>
            <InputTextMaster
              name="id"
              label="ID FIXED ASSET"
              id="id"
              value={formFilter.id}
              onChange={handleChange("id")}
              placeholder="ID"
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="pencarian"
              label="PENCARIAN"
              id="pencarian"
              value={formFilter.search}
              onChange={handleChange("search")}
              placeholder="Pencarian"
            />
          </Grid>

          <Grid item sm={6}>
            <InputReactDatepicker
              isClearable={true}
              selected={formFilter.tglAwal}
              label="TANGGAL"
              handleChangeToday={(e) =>
                setFormFilter({
                  ...formFilter,
                  tglAwal: e,
                })
              }
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  tglAwal: e,
                  // tglAkhir: isNull(e) ? "" : new Date(e),
                })
              }
              withPeriode={true}
            >
              <button
                type={"button"}
                onClick={null}
                style={{
                  borderLeft: "1px solid #EAEAEA",
                  borderTop: "1px solid #EAEAEA",
                  borderBottom: "1px solid #EAEAEA",
                  borderRight: "1px solid #EAEAEA",
                  background: "#fff",
                  padding: "0 0.8rem 0 0.8rem",
                  cursor: "pointer",
                  // borderRadius: "6px 0 0 6px",
                  fontSize: "10px",
                }}
              >
                s/d
              </button>
              <InputReactDatepicker
                isClearable={true}
                selected={formFilter.tglAkhir}
                label=""
                minDate={
                  isNull(formFilter.tglAwal)
                    ? undefined
                    : new Date(formFilter.tglAwal)
                }
                handleChangeToday={(e) =>
                  setFormFilter({
                    ...formFilter,
                    tglAkhir: e,
                  })
                }
                onChange={(e) =>
                  setFormFilter({
                    ...formFilter,
                    tglAkhir: e,
                  })
                }
                withParentPeriode={true}
              />
              {/* <div
                style={{
                  cursor: "pointer",
                  marginTop: "-1.7rem",
                  position: "absolute",
                  right: "2rem",
                }}
              >
                <InputCheckboxMaster
                  checked={formFilter.tgl_aktif}
                  name="tgl_aktif"
                  id="tgl_aktif"
                  label="Dengan Tanggal"
                  onChange={() =>
                    setFormFilter({
                      ...formFilter,
                      tgl_aktif: !formFilter.tgl_aktif,
                    })
                  }
                />
              </div> */}
            </InputReactDatepicker>
          </Grid>
          <Grid item sm={2}>
            <InputTextMaster
              name="id"
              label="ID PEMBELIAN"
              id="id"
              value={formFilter.pembelian_id}
              onChange={handleChange("pembelian_id")}
              placeholder="ID Pembelian"
            />
          </Grid>
          <Grid item sm={2}>
            <InputOptionMaster
              name="gudang_id"
              label="TIPE FIXED ASSET"
              id="gudang_id"
              withSearch={true}
              data={tipe_asset}
              value={formFilter.type_assets_id}
              labelValue={formFilter.type_assets_name}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormFilter({
                    ...formFilter,
                    type_assets_id: null,
                    type_assets_name: "Pilih Tipe Asset",
                  });
                } else {
                  setFormFilter({
                    ...formFilter,
                    type_assets_id: e?.value,
                    type_assets_name: e?.label,
                  });
                }
              }}
            />
          </Grid>
          <Grid item sm={2}>
            <InputOptionMaster
              name="gudang_id"
              label="GUDANG FIXED ASSET"
              id="gudang_id"
              withSearch={true}
              data={gudangUtama}
              value={formFilter.gudang_id}
              labelValue={formFilter.gudang}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormFilter({
                    ...formFilter,
                    gudang_id: null,
                    gudang: "Pilih Gudang",
                  });
                } else {
                  setFormFilter({
                    ...formFilter,
                    gudang_id: e?.value,
                    gudang: e?.label,
                  });
                }
              }}
            />
          </Grid>
          <Grid item sm={2}>
            <InputOptionMaster
              name="produsen_id"
              label="PRODUSEN"
              id="produsen_id"
              withSearch={true}
              data={produsen}
              value={formFilter.produsen_id}
              labelValue={formFilter.produsen}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormFilter({
                    ...formFilter,
                    produsen_id: null,
                    produsen: "Pilih Produsen",
                  });
                } else {
                  setFormFilter({
                    ...formFilter,
                    produsen_id: e?.value,
                    produsen: e?.label,
                  });
                }
              }}
            />
          </Grid>
          <Grid item sm={2}>
            <InputOptionMaster
              name="supplier_id"
              label="SUPPLIER"
              id="supplier_id"
              withSearch={true}
              data={supplier}
              value={formFilter.supplier_id}
              labelValue={formFilter.supplier}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormFilter({
                    ...formFilter,
                    supplier_id: null,
                    supplier: "Pilih Supplier",
                  });
                } else {
                  setFormFilter({
                    ...formFilter,
                    supplier_id: e?.value,
                    supplier: e?.label,
                  });
                }
              }}
            />
          </Grid>
          <Grid item sm={2}>
            <InputOptionMaster
              name="status_kelengkapan_id"
              label="STATUS KELENGKAPAN"
              id="status_kelengkapan_id"
              withSearch={true}
              data={[
                {
                  value: "",
                  label: "SEMUA",
                },
                {
                  value: 0,
                  label: "BELUM LENGKAP",
                },
                {
                  value: 1,
                  label: "SUDAH LENGKAP",
                },
              ]}
              value={formFilter?.status_kelengkapan}
              labelValue={formFilter?.status_kelengkapan_nama}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormFilter({
                    ...formFilter,
                    status_kelengkapan: null,
                    status_kelengkapan_nama: "Semua",
                  });
                } else {
                  setFormFilter({
                    ...formFilter,
                    status_kelengkapan: e.value,
                    status_kelengkapan_nama: e.label,
                  });
                }
              }}
            />
          </Grid>
        </Grid>
        <br />
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <MasterButton
            name={"RESET"}
            outline={true}
            color={"danger"}
            type={"button"}
            size={"md"}
            onClick={() => setFormFilter(RESET_STATE_FORM_FILTER)}
          />
          <Box sx={{ display: "flex", gap: "16px" }}>
            {withExportButton ? (
              <>
                <MasterButton
                  type={"button"}
                  color="primary-cyan"
                  name={"Export List"}
                  size="md"
                  onClick={() => setShowModalExportList(!showModalExportList)}
                />

                <MasterButton
                  type={"button"}
                  color="warning"
                  name={isLoading ? "Loading..." : "EXPORT"}
                  disabled={isLoading}
                  size="md"
                  onClick={handleExport}
                />
              </>
            ) : (
              <></>
            )}
            <MasterButton
              name={"CARI"}
              outline={true}
              color={"green"}
              onClick={handleSubmit}
              type={typeButton}
              size={"md"}
            />
          </Box>
        </Grid>
        <br />
      </form>
      <Divider />
      {showModalExportList && (
        <ModalExportList
          title={"Export Daftar Fixed Asset"}
          showModal={() => setShowModalExportList(false)}
          type="daftar_asset"
          service={BASE_URL_3}
        />
      )}
    </>
  );
}
